import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { useGetShiftTypesQuery } from "AppQuries/shift/type/shift-type";
import { Info } from "react-feather";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const PayrollForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <div className="form-row row">
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="fullName"
            type="text"
            placeholder="Employee Name"
            className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
            label="Employee Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Employee Name is required"
            defaultValue=""
            readOnly={true}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="departmentName"
            type="text"
            placeholder="Department Name"
            className={`form-control ${
              errors.departmentName ? "is-invalid" : ""
            }`}
            label="Department Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Department Name is required"
            defaultValue=""
            readOnly={true}
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="salaryType"
            type="text"
            placeholder="Salary Type"
            className={`form-control ${errors.salaryType ? "is-invalid" : ""}`}
            label="Salary Type"
            labelClassName="form-label"
            required={true}
            requiredMessage="Salary Type is required"
            defaultValue=""
            readOnly={true}
          />
        </div>
      </div>
      <div className="form-row row">
        <div className="col-md-6 col-sg-12 mb-3">
          <div className="row">
            <div className="col-12">
              {watch("salaryType") === "Hourly" ? (
                <Input
                  name="hourlySalary"
                  type="text"
                  placeholder="Hourly Salary"
                  className={`form-control ${
                    errors.hourlySalary ? "is-invalid" : ""
                  }`}
                  label="Hourly Salary"
                  labelClassName="form-label"
                  required={true}
                  requiredMessage="Hourly Salary is required"
                  defaultValue=""
                  readOnly={true}
                />
              ) : watch("salaryType") === "Daily" ? (
                <Input
                  name="dailySalary"
                  type="text"
                  placeholder="Daily Salary"
                  className={`form-control ${
                    errors.basicSalary ? "is-invalid" : ""
                  }`}
                  label="Daily Salary"
                  labelClassName="form-label"
                  required={true}
                  requiredMessage="Daily Salary is required"
                  defaultValue=""
                  readOnly={true}
                />
              ) : watch("salaryType") === "Monthly" ? (
                <Input
                  name="basicSalary"
                  type="text"
                  placeholder="Basic Salary"
                  className={`form-control ${
                    errors.basicSalary ? "is-invalid" : ""
                  }`}
                  label="Basic Salary"
                  labelClassName="form-label"
                  required={true}
                  requiredMessage="Basic Salary is required"
                  defaultValue=""
                  readOnly={true}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-12">
              <Input
                name="monthlySalary"
                type="text"
                placeholder="Monthly Salary"
                className={`form-control ${
                  errors.monthlySalary ? "is-invalid" : ""
                }`}
                label="Monthly Salary"
                labelClassName="form-label"
                required={true}
                requiredMessage="Monthly Salary is required"
                defaultValue=""
                readOnly={true}
              />
            </div>

            <div className="col-12">
              <Input
                name="addition"
                type="text"
                placeholder="Addition"
                className={`form-control ${
                  errors.addition ? "is-invalid" : ""
                }`}
                label="Addition"
                labelClassName="form-label"
                required={true}
                requiredMessage="Addition is required"
                defaultValue=""
                readOnly={true}
              />
            </div>

            {/* <div className="col-12">
              <Input
                name="oT1HourlySalary"
                type="text"
                placeholder="OT1 Hourly Salary"
                className={`form-control ${
                  errors.oT1HourlySalary ? "is-invalid" : ""
                }`}
                label="OT1 Hourly Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT1 Hourly Salary is required"
                defaultValue=""
                readOnly={true}
              />
            </div>

            <div className="col-12">
              <Input
                name="oT2HourlySalary"
                type="text"
                placeholder="OT2 Hourly Salary"
                className={`form-control ${
                  errors.oT2HourlySalary ? "is-invalid" : ""
                }`}
                label="OT2 Hourly Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT2 Hourly Salary is required"
                defaultValue=""
                readOnly={true}
              />
            </div>

            <div className="col-12">
              <Input
                name="publicHolidayHoursSalary"
                type="text"
                placeholder="Public Holiday Salary"
                className={`form-control ${
                  errors.publicHolidayHoursSalary ? "is-invalid" : ""
                }`}
                label="Public Holiday Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="Public Holiday Salary is required"
                defaultValue=""
                readOnly={true}
              />
            </div>
            <div className="col-12">
              <Input
                name="publicHolidayOTHoursSalary"
                type="text"
                placeholder="Public Holiday OT Salary"
                className={`form-control ${
                  errors.publicHolidayOTHoursSalary ? "is-invalid" : ""
                }`}
                label="Public Holiday OT Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="Public Holiday OT Salary is required"
                defaultValue=""
                readOnly={true}
              />
            </div> */}
            <div className="col-12">
              <Input
                name="grossSalary"
                type="text"
                placeholder="Gross Salary"
                className={`form-control ${
                  errors.grossSalary ? "is-invalid" : ""
                }`}
                label="Gross Salary"
                labelClassName="form-label"
                required={true}
                requiredMessage="Gross Salary is required"
                defaultValue=""
                readOnly={true}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sg-12 mb-3">
          <div className="row">
            <div className="col-12">
              <Input
                name="employeeCpf"
                type="text"
                placeholder="Employee Cpf"
                className={`form-control ${
                  errors.employeeCpf ? "is-invalid" : ""
                }`}
                label="Employee Cpf"
                labelClassName="form-label"
                required={false}
                requiredMessage="Employee Cpf is required"
                defaultValue=""
                readOnly={true}
              />
            </div>
            <div className="col-12">
              <Input
                name="employerCpf"
                type="text"
                placeholder="Employer Cpf"
                className={`form-control ${
                  errors.employerCpf ? "is-invalid" : ""
                }`}
                label="Employer Cpf"
                labelClassName="form-label"
                required={false}
                requiredMessage="Employer Cpf is required"
                defaultValue=""
                readOnly={true}
              />
            </div>
            <div className="col-12">
              <Input
                name="deduction"
                type="text"
                placeholder="Deduction"
                className={`form-control ${
                  errors.deduction ? "is-invalid" : ""
                }`}
                label="Deduction"
                labelClassName="form-label"
                required={true}
                requiredMessage="Deduction is required"
                defaultValue=""
                readOnly={true}
              />
            </div>
            <div className="col-12">
              <Input
                name="netPay"
                type="text"
                placeholder="Net Pay"
                className={`form-control ${errors.netPay ? "is-invalid" : ""}`}
                label="Net Pay"
                labelClassName="form-label"
                required={true}
                requiredMessage="Net Pay is required"
                defaultValue=""
                readOnly={true}
              />
            </div>

            {/* <div className="col-12">
              <Input
                name="normalWorkingHoursInMonth"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.normalWorkingHoursInMonth ? "is-invalid" : ""
                }`}
                label="Normal Working Hours"
                labelClassName="form-label"
                required={false}
                requiredMessage=""
                defaultValue=""
              />
            </div>
            <div className="col-12">
              <Input
                name="payrollValue"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.payrollValue ? "is-invalid" : ""
                }`}
                label={
                  watch("salaryType") === "Hourly"
                    ? "Hours Worked"
                    : "Days Worked"
                }
                labelClassName="form-label"
                required={false}
                requiredMessage=""
                defaultValue=""
                readOnly={true}
              />
            </div> */}
            {/* {watch("salaryType") !== "Hourly" && (
              <div className="col-12">
                <Input
                  name="noOfOtworkingDays"
                  type="text"
                  placeholder="OT Days Worked"
                  className={`form-control ${
                    errors.noOfOtworkingDays ? "is-invalid" : ""
                  }`}
                  label="OT Days Worked"
                  labelClassName="form-label"
                  required={false}
                  requiredMessage="OT Days Worked is required"
                  defaultValue=""
                  readOnly={true}
                />
              </div>
            )} */}

            {/* <div className="col-12">
              <Input
                name="oT1Hours"
                type="text"
                placeholder="OT1 Hours"
                className={`form-control ${
                  errors.oT1Hours ? "is-invalid" : ""
                }`}
                label="OT1 Hours"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT1 Hours is required"
                defaultValue=""
                // readOnly={true}
              />
            </div>

            <div className="col-12">
              <Input
                name="oT2Hours"
                type="text"
                placeholder="OT2 Hours"
                className={`form-control ${
                  errors.oT2Hours ? "is-invalid" : ""
                }`}
                label="OT2 Hours"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT2 Hours is required"
                defaultValue=""
                // readOnly={true}
              />
            </div>
            {watch("salaryType") !== "Hourly" && (
              <div className="col-12">
                <Input
                  name="noOfOtworkingDays"
                  type="text"
                  placeholder="OT Days Worked"
                  className={`form-control ${
                    errors.noOfOtworkingDays ? "is-invalid" : ""
                  }`}
                  label="OT Days Worked"
                  labelClassName="form-label"
                  required={false}
                  requiredMessage="OT Days Worked is required"
                  defaultValue=""
                  readOnly={true}
                />
              </div>
            )} */}

            {/* {watch("salaryType") === "Hourly" && (
              <div className="col-12">
                <Input
                  name="publicHolidayOTHours"
                  type="text"
                  placeholder="Public Holiday Hours"
                  className={`form-control ${
                    errors.publicHolidayHours ? "is-invalid" : ""
                  }`}
                  label="Public Holiday Hours"
                  labelClassName="form-label"
                  required={false}
                  requiredMessage="Public Holiday Hours is required"
                  defaultValue=""
                />

                <Input
                  name="publicHolidayHours"
                  type="text"
                  placeholder="Public Holiday OT Hours"
                  className={`form-control ${
                    errors.publicHolidayOTHours ? "is-invalid" : ""
                  }`}
                  label="Public Holiday OT Hours"
                  labelClassName="form-label"
                  required={false}
                  requiredMessage="Public Holiday Hours OT is required"
                  defaultValue=""
                  readOnly={true}
                />
              </div>
            )}
            <div className="col-12">
              <Input
                name="additionalHours"
                type="text"
                placeholder="Additional Hours"
                className={`form-control ${
                  errors.additionalHours ? "is-invalid" : ""
                }`}
                label="Additional Hours"
                labelClassName="form-label"
                required={false}
                requiredMessage="Additional Hours is required"
                defaultValue=""
              />
            </div>
            <div className="col-12">
              <Input
                name="deductionHours"
                type="text"
                placeholder="Deduction Hours"
                className={`form-control ${
                  errors.deductionHours ? "is-invalid" : ""
                }`}
                label="Deduction Hours"
                labelClassName="form-label"
                required={false}
                requiredMessage="Deduction Hours is required"
                defaultValue=""
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollForm;
